// import React, { useState, useEffect, useMemo, useContext } from "react";
// import { Country, State, City } from "country-state-city";
// import { MapPin, Search, ChevronRight, X } from "lucide-react";
// import { Modal } from "react-bootstrap";
// import { LocationContext } from "../../contexts/LocationContext";
// import "./LocationModal.css";

// const LocationModal = ({ isOpen, onClose }) => {
//   const { updateLocation } = useContext(LocationContext);
//   const [selectedCountry, setSelectedCountry] = useState("IN");
//   const [selectedState, setSelectedState] = useState("");
//   const [cities, setCities] = useState([]);
//   const [filteredCities, setFilteredCities] = useState([]);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [loading, setLoading] = useState(false);
//   const [displayLocation, setDisplayLocation] = useState("Select Location");
//   const [detecting, setDetecting] = useState(false);
//   const [selectedCountryName, setSelectedCountryName] = useState("India");
//   const [selectedStateName, setSelectedStateName] = useState("");
//   const MOBILE_BREAKPOINT = 768;
//   const [isMobile, setIsMobile] = useState(
//     () => window.innerWidth <= MOBILE_BREAKPOINT,
//   );

//   const popularCities = [
//     {
//       name: "Mumbai",
//       state: "Maharashtra",
//       stateCode: "MH",
//       icon: "/city/mumbai.png",
//     },
//     { name: "Delhi", state: "Delhi", stateCode: "DL", icon: "/city/delhi.png" },
//     {
//       name: "Bengaluru",
//       state: "Karnataka",
//       stateCode: "KA",
//       icon: "/city/bengaluru.png",
//     },
//     {
//       name: "Hyderabad",
//       state: "Telangana",
//       stateCode: "TG",
//       icon: "/city/hyderabad.png",
//     },
//     {
//       name: "Ahmedabad",
//       state: "Gujarat",
//       stateCode: "GJ",
//       icon: "/city/ahmedabad.png",
//     },
//     {
//       name: "Chennai",
//       state: "Tamil Nadu",
//       stateCode: "TN",
//       icon: "/city/chennai.png",
//     },
//     {
//       name: "Kolkata",
//       state: "West Bengal",
//       stateCode: "WB",
//       icon: "/city/kolkata.png",
//     },
//     {
//       name: "Pune",
//       state: "Maharashtra",
//       stateCode: "MH",
//       icon: "/city/pune.png",
//     },
//   ];

//   const countries = useMemo(() => Country.getAllCountries(), []);
//   const states = useMemo(() => {
//     return selectedCountry ? State.getStatesOfCountry(selectedCountry) : [];
//   }, [selectedCountry]);

//   useEffect(() => {
//     const handleResize = () => {
//       setIsMobile(window.innerWidth <= MOBILE_BREAKPOINT);
//     };

//     window.addEventListener("resize", handleResize);

//     return () => {
//       window.removeEventListener("resize", handleResize);
//     };
//   }, []);

//   useEffect(() => {
//     const country = countries.find((c) => c.isoCode === selectedCountry);
//     setSelectedCountryName(country?.name || "India");
//   }, [selectedCountry, countries]);

//   useEffect(() => {
//     setLoading(true);
//     let cityList = [];
//     if (selectedState) {
//       cityList = City.getCitiesOfState(selectedCountry, selectedState);
//       const state = states.find((s) => s.isoCode === selectedState);
//       setSelectedStateName(state?.name || "");
//     } else {
//       cityList = City.getCitiesOfCountry(selectedCountry);
//       setSelectedStateName("");
//     }
//     if (cityList && cityList.length > 0) {
//       cityList.sort((a, b) => a.name.localeCompare(b.name));
//       setCities(cityList);
//       setFilteredCities(cityList);
//     } else {
//       setCities([]);
//       setFilteredCities([]);
//     }
//     setLoading(false);
//   }, [selectedCountry, selectedState, states]);

//   useEffect(() => {
//     if (!searchTerm) {
//       setFilteredCities(cities);
//     } else {
//       const lowerQuery = searchTerm.toLowerCase();
//       const filtered = cities.filter((c) =>
//         c.name.toLowerCase().includes(lowerQuery),
//       );
//       setFilteredCities(filtered);
//     }
//   }, [searchTerm, cities]);

//   const handleCountryChange = (e) => {
//     const countryCode = e.target.value;
//     setSelectedCountry(countryCode);
//     setSelectedState("");
//     setSearchTerm("");
//   };

//   const handleStateChange = (e) => {
//     const stateCode = e.target.value;
//     setSelectedState(stateCode);
//     setSearchTerm("");
//   };

//   const detectLocation = () => {
//     if (!navigator.geolocation) return alert("Geolocation not supported");
//     setDetecting(true);
//     navigator.geolocation.getCurrentPosition(
//       async (pos) => {
//         const { latitude, longitude } = pos.coords;
//         try {
//           const res = await fetch(
//             `https://api.bigdatacloud.net/data/reverse-geocode-client?latitude=${latitude}&longitude=${longitude}&localityLanguage=en`,
//           );
//           const data = await res.json();
//           const detectedCountryCode = data.countryCode;
//           if (detectedCountryCode) {
//             setSelectedCountry(detectedCountryCode);
//           }
//           handleSelect(
//             data.city || data.locality,
//             data.principalSubdivision,
//             detectedCountryCode,
//           );
//         } catch (err) {
//           console.error(err);
//           alert("Could not detect address.");
//         } finally {
//           setDetecting(false);
//         }
//       },
//       () => {
//         setDetecting(false);
//         alert("Location access denied");
//       },
//     );
//   };

//   const handleSelect = (cityName, stateName, countryCode = selectedCountry) => {
//     const country = countries.find((c) => c.isoCode === countryCode);
//     const cName = country?.name || selectedCountryName;
//     const sName = stateName || selectedStateName;
//     const fullLocation = `${cityName}, ${sName ? sName + ", " : ""}${cName}`;
//     setDisplayLocation(fullLocation);
//     const locationData = {
//       city: cityName,
//       state: sName,
//       country: cName,
//       countryCode: countryCode,
//     };
//     updateLocation(locationData);
//     localStorage.setItem("userLocation", JSON.stringify(locationData));
//     handleClose();
//   };

//   const handleClose = () => {
//     const container = document.querySelector(".location-modal-container");
//     if (container && isMobile) {
//       container.style.animation = "slideDown 0.3s ease-out";
//       setTimeout(() => {
//         onClose();
//         setSearchTerm("");
//         window.touchStartY = null;
//       }, 300);
//     } else {
//       onClose();
//       setSearchTerm("");
//       window.touchStartY = null;
//     }
//   };

//   useEffect(() => {
//     const savedLocation = localStorage.getItem("userLocation");
//     if (savedLocation) {
//       try {
//         const location = JSON.parse(savedLocation);
//         setDisplayLocation(
//           `${location.city}, ${location.state ? location.state + ", " : ""}${location.country}`,
//         );
//         updateLocation(location);
//       } catch (err) {
//         console.error("Error loading saved location:", err);
//       }
//     }
//   }, []);

//   const handleTouchStart = (e) => {
//     if (isMobile) {
//       const filtersContainer = document.querySelector(".filters-container");
//       if (filtersContainer && filtersContainer.contains(e.target)) return;
//       window.touchStartY = e.touches[0].clientY;
//     }
//   };

//   useEffect(() => {
//     const handleTouchMove = (e) => {
//       if (!isOpen || !isMobile || !window.touchStartY) return;
//       const filtersContainer = document.querySelector(".filters-container");
//       const searchContainer = document.querySelector(".search-container");
//       if (
//         (filtersContainer && filtersContainer.contains(e.target)) ||
//         (searchContainer && searchContainer.contains(e.target))
//       )
//         return;
//       const diff = e.touches[0].clientY - window.touchStartY;
//       if (diff > 80) {
//         handleClose();
//       }
//     };

//     if (isOpen) {
//       document.addEventListener("touchmove", handleTouchMove, {
//         passive: true,
//       });
//     }
//     return () => {
//       document.removeEventListener("touchmove", handleTouchMove);
//     };
//   }, [isOpen, isMobile]);

//   useEffect(() => {
//     if (isOpen) {
//       document.body.classList.add("modal-open");
//       const scrollBody = document.querySelector(".modal-scroll-body");
//       if (scrollBody) {
//         scrollBody.addEventListener("wheel", (e) => e.stopPropagation(), {
//           passive: true,
//         });
//       }
//     } else {
//       document.body.classList.remove("modal-open");
//     }
//     return () => {
//       document.body.classList.remove("modal-open");
//     };
//   }, [isOpen]);

//   return (
//     <Modal
//       show={isOpen}
//       onHide={handleClose}
//       centered={!isMobile}
//       dialogClassName={`custom-location-modal ${isMobile ? "custom-location-modal--drawer" : "custom-location-modal--desktop"}`}
//       contentClassName="location-modal-content"
//       backdrop="static"
//       keyboard={false}
//     >
//       <div
//         className={`location-modal-container ${isMobile ? "location-modal-container--drawer" : "location-modal-container--desktop"}`}
//         onTouchStart={handleTouchStart}
//       >
//         <div className="modal-header-custom">
//           <h5>Select Location</h5>
//           <button onClick={handleClose} className="close-btn">
//             <X size={20} />
//           </button>
//         </div>

//         <div className="filters-container" onClick={(e) => e.stopPropagation()}>
//           <div className="filter-group">
//             <label>Country</label>
//             <select
//               value={selectedCountry}
//               onChange={handleCountryChange}
//               className="filter-select"
//               onClick={(e) => e.stopPropagation()}
//             >
//               {countries.map((country) => (
//                 <option key={country.isoCode} value={country.isoCode}>
//                   {country.name}
//                 </option>
//               ))}
//             </select>
//           </div>

//           {states.length > 0 && (
//             <div className="filter-group">
//               <label>State</label>
//               <select
//                 value={selectedState}
//                 onChange={handleStateChange}
//                 className="filter-select"
//                 onClick={(e) => e.stopPropagation()}
//               >
//                 <option value="">All States</option>
//                 {states.map((state) => (
//                   <option key={state.isoCode} value={state.isoCode}>
//                     {state.name}
//                   </option>
//                 ))}
//               </select>
//             </div>
//           )}
//         </div>

//         <div className="search-container">
//           <Search className="search-icon" size={20} />
//           <input
//             type="text"
//             placeholder="Search city, area or locality"
//             value={searchTerm}
//             onChange={(e) => setSearchTerm(e.target.value)}
//             className="search-input"
//           />
//         </div>

//         <div className="modal-scroll-body">
//           <div className="current-location-row" onClick={detectLocation}>
//             <div className="icon-box">
//               <img src="/city/gps.png" alt="GPS" />
//             </div>
//             <div className="location-details">
//               <span className="primary-text">Use Current Location</span>
//               <span className="secondary-text">
//                 {detecting ? "Detecting..." : "Using GPS"}
//               </span>
//             </div>
//           </div>

//           {!searchTerm && !selectedState && (
//             <div className="popular-section">
//               <h6>Popular Cities</h6>
//               <div className="popular-grid">
//                 {popularCities.map((city, idx) => (
//                   <div
//                     key={idx}
//                     className="city-card"
//                     onClick={() => handleSelect(city.name, city.state)}
//                   >
//                     <div className="city-img-wrapper">
//                       <img src={city.icon} alt={city.name} />
//                     </div>
//                     <span className="city-name">{city.name}</span>
//                   </div>
//                 ))}
//               </div>
//             </div>
//           )}

//           <div className="all-cities-section">
//             <h6>{searchTerm ? "Search Results" : "All Cities"}</h6>
//             {loading ? (
//               <div className="loading-state">Loading cities...</div>
//             ) : (
//               <ul className="cities-list">
//                 {filteredCities.length > 0 ? (
//                   filteredCities.map((city, idx) => (
//                     <li
//                       key={`${city.name}-${idx}`}
//                       onClick={() => handleSelect(city.name, selectedStateName)}
//                       className="city-list-item"
//                     >
//                       <MapPin size={16} className="list-icon" />
//                       <span className="city-name">{city.name}</span>
//                     </li>
//                   ))
//                 ) : (
//                   <div className="empty-state">No cities found</div>
//                 )}
//               </ul>
//             )}
//           </div>
//         </div>
//       </div>
//       <div className="modal-close-area" onClick={handleClose}></div>
//     </Modal>
//   );
// };

// export default LocationModal;

import React, { useState, useEffect, useMemo, useContext } from "react";
import { Country, City } from "country-state-city";
import { Search, X, Crosshair } from "lucide-react";
import { Dialog, SwipeableDrawer } from "@mui/material";
import { LocationContext } from "../../contexts/LocationContext";
import "./LocationModal.css";

const LocationModal = ({ isOpen, onClose }) => {
  const { updateLocation } = useContext(LocationContext);

  // Defaulting to India for the main list, but you can fetch all global cities if needed
  const [cities, setCities] = useState([]);
  const [filteredCities, setFilteredCities] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedLetter, setSelectedLetter] = useState("A");
  const [loading, setLoading] = useState(false);
  const [detecting, setDetecting] = useState(false);

  const MOBILE_BREAKPOINT = 768;
  const [isMobile, setIsMobile] = useState(
    () => window.innerWidth <= MOBILE_BREAKPOINT,
  );

  const alphabets = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");

  const popularCities = [
    {
      name: "Abu Dhabi",
      state: "Abu Dhabi",
      countryCode: "AE",
      icon: "/city/abudhabi.png",
    },
    {
      name: "Ahmedabad",
      state: "Gujarat",
      countryCode: "IN",
      icon: "/city/ahmedabad.png",
    },
    {
      name: "Bengaluru",
      state: "Karnataka",
      countryCode: "IN",
      icon: "/city/bengaluru.png",
    },
    {
      name: "Chandigarh",
      state: "Chandigarh",
      countryCode: "IN",
      icon: "/city/chandigarh.png",
    },
    {
      name: "Chennai",
      state: "Tamil Nadu",
      countryCode: "IN",
      icon: "/city/chennai.png",
    },
    {
      name: "Delhi NCR",
      state: "Delhi",
      countryCode: "IN",
      icon: "/city/delhi.png",
    },
    {
      name: "Dubai",
      state: "Dubai",
      countryCode: "AE",
      icon: "/city/dubai.png",
    },
    { name: "Goa", state: "Goa", countryCode: "IN", icon: "/city/goa.png" },
    {
      name: "Hyderabad",
      state: "Telangana",
      countryCode: "IN",
      icon: "/city/hyderabad.png",
    },
    {
      name: "Kolkata",
      state: "West Bengal",
      countryCode: "IN",
      icon: "/city/kolkata.png",
    },
    {
      name: "Mumbai",
      state: "Maharashtra",
      countryCode: "IN",
      icon: "/city/mumbai.png",
    },
    {
      name: "Pune",
      state: "Maharashtra",
      countryCode: "IN",
      icon: "/city/pune.png",
    },
  ];

  useEffect(() => {
    const handleResize = () =>
      setIsMobile(window.innerWidth <= MOBILE_BREAKPOINT);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Load cities (Combining India and UAE for the popular ones shown, or just load IN)
  useEffect(() => {
    setLoading(true);
    // Fetching India cities as the base
    const indiaCities = City.getCitiesOfCountry("IN");
    const uaeCities = City.getCitiesOfCountry("AE");
    let allCities = [...indiaCities, ...uaeCities];

    // Remove duplicates and sort
    const uniqueCities = Array.from(new Set(allCities.map((a) => a.name)))
      .map((name) => allCities.find((a) => a.name === name))
      .sort((a, b) => a.name.localeCompare(b.name));

    setCities(uniqueCities);
    setLoading(false);
  }, []);

  // Filter logic for Search Term or A-Z Alphabet
  useEffect(() => {
    if (searchTerm) {
      const lowerQuery = searchTerm.toLowerCase();
      setFilteredCities(
        cities.filter((c) => c.name.toLowerCase().includes(lowerQuery)),
      );
    } else {
      setFilteredCities(
        cities.filter((c) => c.name.toUpperCase().startsWith(selectedLetter)),
      );
    }
  }, [searchTerm, selectedLetter, cities]);

  const detectLocation = () => {
    if (!navigator.geolocation) return alert("Geolocation not supported");
    setDetecting(true);
    navigator.geolocation.getCurrentPosition(
      async (pos) => {
        const { latitude, longitude } = pos.coords;
        try {
          const res = await fetch(
            `https://api.bigdatacloud.net/data/reverse-geocode-client?latitude=${latitude}&longitude=${longitude}&localityLanguage=en`,
          );
          const data = await res.json();
          handleSelect(
            data.city || data.locality,
            data.principalSubdivision,
            data.countryCode,
          );
        } catch (err) {
          console.error(err);
          alert("Could not detect address.");
        } finally {
          setDetecting(false);
        }
      },
      () => {
        setDetecting(false);
        alert("Location access denied");
      },
    );
  };

  const handleSelect = (cityName, stateName, countryCode = "IN") => {
    const locationData = {
      city: cityName,
      state: stateName,
      countryCode: countryCode,
    };
    updateLocation(locationData);
    localStorage.setItem("userLocation", JSON.stringify(locationData));
    handleClose();
  };

  const handleClose = () => {
    setSearchTerm("");
    onClose();
  };

  useEffect(() => {
    if (isOpen) {
      document.body.classList.add("modal-open");
      document.documentElement.classList.add("modal-open");
    } else {
      document.body.classList.remove("modal-open");
      document.documentElement.classList.remove("modal-open");
    }
    return () => {
      document.body.classList.remove("modal-open");
      document.documentElement.classList.remove("modal-open");
    };
  }, [isOpen]);

  const modalContent = (
    <div
      className={`location-modal-container ${isMobile ? "location-modal-container--drawer" : "location-modal-container--desktop"}`}
      style={{
        background: "#fff",
        display: "flex",
        flexDirection: "column",
        height: "100%",
        overflow: "hidden",
      }}
    >
      {isMobile && <div className="sheet-handle" style={{ marginTop: 12, marginBottom: 4 }} />}
      <div className="modal-header-custom">
        <h5>Select Location</h5>
        <button onClick={handleClose} className="close-btn">
          <X size={24} />
        </button>
      </div>

      <div className="search-container">
        <input
          type="text"
          placeholder="Search city, area or locality"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="search-input"
        />
      </div>

      <div className="modal-scroll-body" data-lenis-prevent>
        <div className="current-location-btn" onClick={detectLocation}>
          <Crosshair size={20} className="target-icon" />
          <span>
            {detecting ? "Detecting location..." : "Use Current Location"}
          </span>
        </div>

        {!searchTerm && (
          <div className="popular-section">
            <h6>Popular Cities</h6>
            <div className="popular-grid">
              {popularCities.map((city, idx) => (
                <div
                  key={idx}
                  className="city-card"
                  onClick={() =>
                    handleSelect(city.name, city.state, city.countryCode)
                  }
                >
                  <div className="city-img-wrapper">
                    {/* Using fallback div for line art if image fails */}
                    <img
                      src={city.icon}
                      alt={city.name}
                      onError={(e) => (e.target.style.display = "none")}
                    />
                  </div>
                  <span className="city-name">{city.name}</span>
                </div>
              ))}
            </div>
          </div>
        )}

        <div className="all-cities-section">
          <h6>All Cities</h6>

          {!searchTerm && (
            <div className="alphabet-nav">
              {alphabets.map((letter) => (
                <span
                  key={letter}
                  className={`alphabet-letter ${selectedLetter === letter ? "active" : ""}`}
                  onClick={() => setSelectedLetter(letter)}
                >
                  {letter}
                </span>
              ))}
            </div>
          )}

          {loading ? (
            <div className="loading-state">Loading cities...</div>
          ) : (
            <div className="cities-multi-col-grid">
              {filteredCities.length > 0 ? (
                filteredCities.map((city, idx) => (
                  <div
                    key={`${city.name}-${idx}`}
                    onClick={() => handleSelect(city.name, city.stateCode)}
                    className="city-grid-item"
                  >
                    {city.name}
                  </div>
                ))
              ) : (
                <div className="empty-state">No cities found</div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );

  if (isMobile) {
    return (
      <SwipeableDrawer
        anchor="bottom"
        open={isOpen}
        onClose={handleClose}
        onOpen={() => {}}
        swipeAreaWidth={56}
        disableDiscovery={false}
        PaperProps={{
          style: {
            height: "90vh",
            borderTopLeftRadius: 24,
            borderTopRightRadius: 24,
            overflow: "hidden",
            background: "transparent"
          },
        }}
      >
        {modalContent}
      </SwipeableDrawer>
    );
  }

  return (
    <Dialog
      open={isOpen}
      onClose={handleClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        style: {
          borderRadius: 20,
          margin: "2rem auto",
          width: "90vw",
          maxWidth: "820px",
          height: "min(85vh, 800px)",
          overflow: "hidden",
          background: "transparent"
        },
      }}
    >
      {modalContent}
    </Dialog>
  );
};



export default LocationModal;
